import { render, staticRenderFns } from "./dialogHelpChineseStyle.vue?vue&type=template&id=0bf6af6d&scoped=true&"
import script from "./dialogHelpChineseStyle.vue?vue&type=script&lang=js&"
export * from "./dialogHelpChineseStyle.vue?vue&type=script&lang=js&"
import style0 from "./dialogHelpChineseStyle.vue?vue&type=style&index=0&id=0bf6af6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf6af6d",
  null
  
)

export default component.exports